import { useEffect, useState, useRef, useMemo } from 'react'
import { useLocation } from "react-router-dom"
import { LocalStorage } from '../../services/localStorage/LocalStorage.services'

import NewAction from './NewAction'

import getAllActionsByTask from '../../services/actions/getAllActionsByTask'
import desactiveAction from '../../services/actions/desactiveActions'

import styles from './Actions.module.css'

const Labels = () => {

  const componentRef = useRef()
  const location = useLocation()

  const dadesRebudes = useMemo(() => location.state || {}, [location.state])
  const [ actions, setActions ] = useState([])
  const [ actionView, setActionView ] = useState({})
  const [ actionDescriptionView, setActionDescriptionView ] = useState([])
  const [ update, setUpdate ] = useState(false)

  useEffect(() => {
    getAllActionsByTask(dadesRebudes.id)
    .then(actions => {
      actions.sort((a, b) => new Date(b.actionDoDate) - new Date(a.actionDoDate))
      setActions(actions)
      const actionsState = actions.map(() => ({ showDescription: false }))
      setActionDescriptionView(actionsState)
    })
  },[update])

  const handleDesactive = (event) => {
    desactiveAction(event.target.parentNode.parentNode.parentNode.parentNode.id)
    setUpdate(!update)
  }

  const handleViewDescription = (index) => {
    setActionDescriptionView(prevActions => 
      prevActions.map((actionDescription, i) => 
      i === index ? { ...actionDescription, showDescription: !actionDescription.showDescription } : actionDescription
      )
    )
  }

  const handleActionView = (event) => {
    event.preventDefault()
    const action = actions.find(element => element._id === event.target.parentNode.id)
    setActionView(action)
  }

  return (
    <div className={styles.container}>
      <div className={styles.columns1}>
          {
            actions ? actions.map((element, index) => {
                const date = element.actionDoDate && new Date(element.actionDoDate).toLocaleDateString()
                const initials = `${element.actionProfessionalId.professionalName.charAt(0).toUpperCase()}${element.actionProfessionalId.professionalLastName1.charAt(0).toUpperCase()}`
                return (
                  <div className={LocalStorage.getItem("id") === element.actionProfessionalId._id ? styles.xat : styles.xatother} key={element._id} id={element._id}>
                    <div className={styles.initials}>
                      <span>{initials}</span>
                    </div>
                    <div className={styles.actionbox}>
                      <div className={styles.actioninfo}>
                        <div>{date}</div>
                        <div className={styles.icons} id={index}>
                          {actionDescriptionView[index].showDescription === false ? <i onClick={() => handleViewDescription(index)} class="fa-solid fa-eye-slash"></i> : <i onClick={() => handleViewDescription(index)} class="fa-solid fa-eye"></i>}
                        </div>
                      </div>
                      <div className={actionDescriptionView[index].showDescription === false ? styles.actionDescription : styles.actionDescriptionHidden}>
                          {element.actionDescription}
                      </div>
                      <div className={styles.actionProfessional}>
                        <div>{element.actionProfessionalId.professionalName} {element.actionProfessionalId.professionalLastName1} {element.actionProfessionalId.professionalLastName2}</div>
                        <div className={styles.icons}>
                          <i onClick={handleActionView} className="fa-solid fa-edit"></i>
                          <i className="fa-solid fa-trash" onClick={handleDesactive}></i>
                        </div>
                      </div>
                    </div>
                  </div>
                )
            }) : null
          }
      </div>
      <div className={styles.columns2}>
        <NewAction update={update} setUpdate={setUpdate} professional={dadesRebudes.professional} id={dadesRebudes.id}></NewAction>
      </div>
    </div>
  )
}

export default Labels
